import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Nav
    dashboard: 'Panel de Control',
    myRequests: 'Mis Solicitudes',
    calendar: 'Calendario',
    approvals: 'Aprobaciones',
    aiReport: 'Informe IA',
    users: 'Gestión de Usuarios',
    teams: 'Equipos',
    settings: 'Configuración',
    export: 'Exportar Excel',
    // Actions
    newVacation: 'Solicitar Vacaciones',
    newRemote: 'Informar Teletrabajo',
    approve: 'Aprobar',
    reject: 'Rechazar',
    cancel: 'Cancelar',
    save: 'Guardar',
    create: 'Crear',
    edit: 'Editar',
    delete: 'Eliminar',
    submit: 'Enviar Solicitud',
    generate: 'Generar Informe',
    logout: 'Cerrar Sesión',
    // Status
    pending: 'Pendiente',
    approved: 'Aprobada',
    rejected: 'Rechazada',
    cancelled: 'Cancelada',
    // Types
    vacation: 'Vacaciones',
    remoteWork: 'Teletrabajo',
    morning: 'Mañana',
    afternoon: 'Tarde',
    fullDay: 'Día completo',
    // Balances
    available: 'Disponibles',
    used: 'Usados',
    remaining: 'Restantes',
    total: 'Total',
    pending_bal: 'Pendiente',
    carryover: 'Arrastrado',
    // Fields
    startDate: 'Fecha inicio',
    endDate: 'Fecha fin',
    date: 'Fecha',
    notes: 'Observaciones',
    location: 'Localización',
    comment: 'Comentario del aprobador',
    workingDays: 'Días laborables',
    // Messages
    loading: 'Cargando...',
    noData: 'Sin datos',
    success: 'Operación realizada correctamente',
    error: 'Ha ocurrido un error',
    confirmCancel: '¿Cancelar esta solicitud?',
    // Roles
    employee: 'Empleado',
    manager: 'Manager',
    admin: 'Administrador',
    // Dashboard
    teamSummary: 'Resumen del equipo',
    pendingApprovals: 'Aprobaciones pendientes',
    onVacationToday: 'De vacaciones hoy',
    remoteToday: 'Teletrabajando hoy',
    myBalance: 'Mi saldo',
    quickActions: 'Acciones rápidas',
    recentRequests: 'Solicitudes recientes',
    // Report
    reportEmployee: 'Informe Individual',
    reportManager: 'Informe de Equipo',
    reportHR: 'Informe Global RRHH',
    generatingReport: 'Generando informe con IA...',
  },
  en: {
    dashboard: 'Dashboard',
    myRequests: 'My Requests',
    calendar: 'Calendar',
    approvals: 'Approvals',
    aiReport: 'AI Report',
    users: 'User Management',
    teams: 'Teams',
    settings: 'Settings',
    export: 'Export Excel',
    newVacation: 'Request Vacation',
    newRemote: 'Request Remote Work',
    approve: 'Approve',
    reject: 'Reject',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    submit: 'Submit Request',
    generate: 'Generate Report',
    logout: 'Log Out',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    vacation: 'Vacation',
    remoteWork: 'Remote Work',
    morning: 'Morning',
    afternoon: 'Afternoon',
    fullDay: 'Full Day',
    available: 'Available',
    used: 'Used',
    remaining: 'Remaining',
    total: 'Total',
    pending_bal: 'Pending',
    carryover: 'Carryover',
    startDate: 'Start date',
    endDate: 'End date',
    date: 'Date',
    notes: 'Notes',
    location: 'Location',
    comment: 'Approver comment',
    workingDays: 'Working days',
    loading: 'Loading...',
    noData: 'No data',
    success: 'Operation completed successfully',
    error: 'An error occurred',
    confirmCancel: 'Cancel this request?',
    employee: 'Employee',
    manager: 'Manager',
    admin: 'Administrator',
    teamSummary: 'Team Summary',
    pendingApprovals: 'Pending Approvals',
    onVacationToday: 'On vacation today',
    remoteToday: 'Working remotely today',
    myBalance: 'My Balance',
    quickActions: 'Quick Actions',
    recentRequests: 'Recent Requests',
    reportEmployee: 'Individual Report',
    reportManager: 'Team Report',
    reportHR: 'Global HR Report',
    generatingReport: 'Generating AI report...',
  }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem('valoriza_lang') || 'es');

  const toggleLang = () => {
    const next = lang === 'es' ? 'en' : 'es';
    setLang(next);
    localStorage.setItem('valoriza_lang', next);
  };

  const t = (key) => translations[lang]?.[key] || translations['es']?.[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
